$(document).on('click', '#CartDrawer-Checkout', function(event) {
  $('#cart').submit();
});

$(document).on('click', '#header-cart', function(event) {
  event.preventDefault(); 
 $('.cart-drawer').addClass('open_cartdrawer');
  $('body').addClass('js-drawer-open');
  $('.cart-overlay').show();
});
$(document).on("click", "[data-action='close-drawer']", function (e) {
  $('.cart-drawer').removeClass('open_cartdrawer');
  $('body').removeClass('js-drawer-open');
  $('.cart-overlay').hide();
});
$(document).on("click", ".cart-overlay", function (e) {
  e.preventDefault();
  $('.cart-drawer').removeClass('open_cartdrawer');
  $('body').removeClass('js-drawer-open');
  $(this).hide();
});
function reslider(){

document.querySelectorAll('.items_options dd').forEach(dd => {
  const url = dd.textContent.trim();
  if (url.includes('cdn.shopify.com-uploadkit.app')) {
    // extract ID from query string
    const match = url.match(/uu=([a-z0-9-]+)/i);
    if (match) {
      const id = match[1];
      const preview = `https://cdn.getuploadkit.com/${id}/-/preview/1200x1200`;
      const thumb   = `https://cdn.getuploadkit.com/${id}/-/resize/300x/`;
      dd.innerHTML = `<span><a href="${preview}" class="uploadkit-preview-link-image" title="Uploaded Image"><img src="${thumb}" style="max-width:50px;max-height:50px;vertical-align:middle;"></a></span>`;
    }
  }
});

    $('.upsell_product').slick({
    infinite: false,
    slidesToShow: 3.5,
    slidesToScroll: 3,
    responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 2
      }
    }
  ]
  });
}
reslider();
function qunatityChange(line, qty){
  fetch('/cart/change', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      line: line,
      quantity: qty,
      sections: ["cart-drawer"],
      sections_url: "/"
    })
  })
  .then(response => response.json())
  .then(cart => {
  console.log(cart);
  if(cart.item_count > 1 ){
  $('.cart-msg').text('Spare weitere 10€ auf jedes zusätzliche Produkt ✨');
  }else{
  $('.cart-msg').text('10€ Rabatt ab dem 2. Produkt + kostenloser Versand 🎉');
  }


  const html = new DOMParser().parseFromString(cart.sections['cart-drawer'], 'text/html');
  $('#my-sidebar-cart').html($(html).find('#my-sidebar-cart').html());
  reslider();

  let mainItemCount = 0;

  if (cart.items && cart.items.length > 0) {
    mainItemCount = cart.items.reduce((total, item) => {
      if (!item.properties || !item.properties._bundleWithItem) {
        return total + item.quantity;
      }
      return total;
    }, 0);
  }
  $('#header-cart .header-cart__count').html(mainItemCount);
  })
  .catch(error => {
    console.error('Error:',error);
  });
}


function drawerRemove(item) {
  var line = $(item).attr('data-index');
  qunatityChange(line, 0);
}

function drawerRemoveAll(item) {
  console.log('Remove item');
  var $item = $(item);
  var bundleKey = $item.attr('data-bundle_item');

  var values = {};
  var bundlePairs = bundleKey.split(",");
  bundlePairs.forEach(function(pair) {
    var cleanPair = pair.trim();
    if (cleanPair) {
      values[cleanPair] = 0;
    }
  });
console.log(values);
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    dataType: 'json',
    data: { updates: values },
    success: function(cart) {

      console.log("Updated cart:", cart);

      // ---- Update cart message ----
      if (cart.item_count > 1) {
        $('.cart-msg').text('Spare weitere 10€ auf jedes zusätzliche Produkt ✨');
      } else {
        $('.cart-msg').text('10€ Rabatt ab dem 2. Produkt + kostenloser Versand 🎉');
      }

      // ---- Update cart drawer section ----
      fetch('/?sections=cart-drawer')
        .then(res => res.json())
        .then(sections => {
          const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          $('#my-sidebar-cart').html($(html).find('#my-sidebar-cart').html());
          reslider();

          // ---- Update header cart count (exclude bundled items) ----
          let mainItemCount = 0;
          if (cart.items && cart.items.length > 0) {
            mainItemCount = cart.items.reduce((total, item) => {
              if (!item.properties || !item.properties._bundleWithItem) {
                return total + item.quantity;
              }
              return total;
            }, 0);
          }
          $('#header-cart .header-cart__count').html(mainItemCount);
          fetchAndCheckCart();
        });
    }
  });
}
